import { Component, Inject, Input, Optional } from '@angular/core';
import { cloneDeep, isEqual } from 'lodash';
import { QPointMultiPolygon } from '@qpoint/utils';
import { QPOINT_POLYGON_DEFAULT_OPTIONS, QPointMapPolygonOptions } from '../map-polygon/map-polygon.component';

@Component({
  selector: 'qpoint-map-polygons',
  template: '',
  standalone: true,
})
export class MapPolygonsComponent {
  private readonly _defaultOptions: QPointMapPolygonOptions = this.defaultOptions || {
    fillColor: 'blue',
    fillOpacity: 0.15,
    strokeWeight: 0,
    zIndex: 100,
    minimumVerticesNumber: 4,
  };

  polygons: QPointMultiPolygon | null = null;

  @Input('polygons') set polygonsSetter(polygons: QPointMultiPolygon) {
    this.polygons = cloneDeep(polygons);
  }

  @Input() options: QPointMapPolygonOptions;

  private currentPolygonOptions: QPointMapPolygonOptions | null;

  constructor(@Inject(QPOINT_POLYGON_DEFAULT_OPTIONS) @Optional() private defaultOptions: QPointMapPolygonOptions) {
  }

  get polygonOptions(): QPointMapPolygonOptions {
    const newOptions = this.createPolygonOptions();

    if (!this.currentPolygonOptions || !isEqual(this.currentPolygonOptions, newOptions)) {
      this.currentPolygonOptions = newOptions;
    }
    return this.currentPolygonOptions;
  }

  private createPolygonOptions(): QPointMapPolygonOptions {
    return {
      ...this._defaultOptions,
      ...this.options,
      editable: false,
      zIndex: this.options?.zIndex ?? this._defaultOptions.zIndex,
      fillOpacity: {
        ...this._defaultOptions,
        ...this.options
      }.fillOpacity
    };
  }
}
